// The Super Admin's Website screen (migration 057): the marketing website's contact details and packages.
export const WEBSITE_STRINGS = {
  en: {
    pfNavWebsite: "Website",
    pfWsTitle: "Marketing website",
    pfWsIntro: "What the public website (deltasa.net) shows. Only what is entered here is published: empty fields are not shown, and the website never invents contact details or prices.",
    pfWsContact: "Contact details",
    pfWsContactHint: "Enter confirmed company details only. Phone and WhatsApp: digits, optionally starting with + (for example +9665XXXXXXXX or 05XXXXXXXX).",
    pfWsCompanyEn: "Company name (English)", pfWsCompanyAr: "Company name (Arabic)",
    pfWsPhone: "Phone", pfWsWhatsapp: "WhatsApp number", pfWsEmail: "Email",
    pfWsAddressEn: "Address (English)", pfWsAddressAr: "Address (Arabic)",
    pfWsHoursEn: "Working hours (English)", pfWsHoursAr: "Working hours (Arabic)",
    pfWsPackages: "Packages on the website",
    pfWsPackagesHint: "Only packages that are active and public can be chosen. A package's price shows only if it has one; otherwise the website says \"Contact us for the price\". Reseller rates are never shown.",
    pfWsNotPublic: "Not public: make it public under Packages first",
    pfWsInactive: "Inactive",
    pfWsNoPackages: "No packages yet.",
    pfWsState: "Also on the website (changed on their own screens)",
    pfWsDemoOn: "Try a demo account: shown (the demo is on)",
    pfWsDemoOff: "Try a demo account: hidden (the demo is off)",
    pfWsSignupOpen: "Registration links: shown (public signup is open)",
    pfWsSignupClosed: "Registration links: hidden (public signup is closed)",
    pfWsSaved: "Website settings saved.",
    fieldPhoneFormat: "Enter digits only, optionally starting with +.",
    pfWsNotPublicErr: "Only active, public packages can be shown on the website.",
    wsSocial: "Social links",
    wsSocialHint: "Optional. The full https address of each page, on the network's own site (for example https://www.linkedin.com/company/…). Empty links are not shown.",
    wsSocialX: "X (Twitter)", wsSocialInstagram: "Instagram", wsSocialLinkedin: "LinkedIn", wsSocialFacebook: "Facebook",
    wsSocialTiktok: "TikTok", wsSocialSnapchat: "Snapchat", wsSocialYoutube: "YouTube",
    fieldSocialUrl: "Enter the full https address of the page on this network's own site.",
    wsPackagesFromEditor: "Chosen in the package editor with \"Show on website\". Only active, public packages appear; the website shows their English and Arabic names and descriptions, the price (or \"Contact us\"), the modules and the limits. Reseller rates are never shown.",
    wsNoPackagesShown: "No package is shown on the website yet.",
    wsEditPackages: "Choose packages",
    wsOnWebsite: "On website",
    wsShowOnWebsite: "Show on website (deltasa.net)",
    wsShowOnWebsiteHint: "The website shows this package's English and Arabic names and descriptions, its price (or \"Contact us for the price\" when it has none), modules and limits. Never reseller rates. Changes appear on the website within 30 seconds of saving.",
    wsShowOnWebsiteNeedsPublic: "Only an active, public package can be shown on the website. Making a package private or inactive takes it off the website."
  },
  ar: {
    pfNavWebsite: "الموقع",
    pfWsTitle: "الموقع التعريفي",
    pfWsIntro: "ما يعرضه الموقع العام (deltasa.net). لا يُنشر إلا ما يُدخل هنا: الحقول الفارغة لا تظهر، ولا يختلق الموقع أي بيانات تواصل أو أسعار.",
    pfWsContact: "بيانات التواصل",
    pfWsContactHint: "أدخل بيانات الشركة المؤكدة فقط. الهاتف وواتساب: أرقام فقط، ويمكن أن تبدأ بعلامة + (مثل ‎+9665XXXXXXXX أو 05XXXXXXXX).",
    pfWsCompanyEn: "اسم الشركة (بالإنجليزية)", pfWsCompanyAr: "اسم الشركة (بالعربية)",
    pfWsPhone: "الهاتف", pfWsWhatsapp: "رقم واتساب", pfWsEmail: "البريد الإلكتروني",
    pfWsAddressEn: "العنوان (بالإنجليزية)", pfWsAddressAr: "العنوان (بالعربية)",
    pfWsHoursEn: "ساعات العمل (بالإنجليزية)", pfWsHoursAr: "ساعات العمل (بالعربية)",
    pfWsPackages: "الباقات في الموقع",
    pfWsPackagesHint: "لا يمكن اختيار إلا الباقات النشطة والعامة. يظهر سعر الباقة فقط إن كان لها سعر، وإلا يعرض الموقع «تواصل معنا لمعرفة السعر». لا تظهر أسعار الموزعين أبدًا.",
    pfWsNotPublic: "غير عامة: اجعلها عامة من شاشة الباقات أولًا",
    pfWsInactive: "غير نشطة",
    pfWsNoPackages: "لا توجد باقات بعد.",
    pfWsState: "يظهر أيضًا في الموقع (يُغيَّر من شاشته الخاصة)",
    pfWsDemoOn: "جرّب حسابًا تجريبيًا: ظاهر (الحساب التجريبي مفعّل)",
    pfWsDemoOff: "جرّب حسابًا تجريبيًا: مخفي (الحساب التجريبي متوقف)",
    pfWsSignupOpen: "روابط التسجيل: ظاهرة (التسجيل العام مفتوح)",
    pfWsSignupClosed: "روابط التسجيل: مخفية (التسجيل العام مغلق)",
    pfWsSaved: "حُفظت إعدادات الموقع.",
    fieldPhoneFormat: "أدخل أرقامًا فقط، ويمكن أن تبدأ بعلامة +.",
    pfWsNotPublicErr: "لا يمكن عرض إلا الباقات النشطة والعامة في الموقع.",
    wsSocial: "روابط التواصل الاجتماعي",
    wsSocialHint: "اختيارية. العنوان الكامل لكل صفحة بصيغة https على موقع الشبكة نفسها (مثل https://www.linkedin.com/company/…). الروابط الفارغة لا تظهر.",
    wsSocialX: "إكس (تويتر)", wsSocialInstagram: "إنستغرام", wsSocialLinkedin: "لينكدإن", wsSocialFacebook: "فيسبوك",
    wsSocialTiktok: "تيك توك", wsSocialSnapchat: "سناب شات", wsSocialYoutube: "يوتيوب",
    fieldSocialUrl: "أدخل العنوان الكامل للصفحة بصيغة https على موقع هذه الشبكة نفسها.",
    wsPackagesFromEditor: "تُختار من محرر الباقات بخيار «عرض في الموقع». لا تظهر إلا الباقات النشطة والعامة؛ ويعرض الموقع اسمها ووصفها بالعربية والإنجليزية، والسعر (أو «تواصل معنا»)، والوحدات والحدود. لا تظهر أسعار الموزعين أبدًا.",
    wsNoPackagesShown: "لا توجد باقة معروضة في الموقع بعد.",
    wsEditPackages: "اختيار الباقات",
    wsOnWebsite: "في الموقع",
    wsShowOnWebsite: "عرض في الموقع (deltasa.net)",
    wsShowOnWebsiteHint: "يعرض الموقع اسم هذه الباقة ووصفها بالعربية والإنجليزية، وسعرها (أو «تواصل معنا لمعرفة السعر» إن لم يكن لها سعر)، ووحداتها وحدودها. لا تظهر أسعار الموزعين أبدًا. تظهر التغييرات في الموقع خلال 30 ثانية من الحفظ.",
    wsShowOnWebsiteNeedsPublic: "لا يمكن عرض إلا الباقة النشطة والعامة في الموقع. جعل الباقة خاصة أو غير نشطة يزيلها من الموقع."
  }
};
